import {
    CUSTOM_BILLING_PERIOD_PARAM,
    SHOW_LOGGING_IN_PAGE_QUERY_PARAM,
    checkExtensionStatus,
    tutorials,
    useOpenInNewTab,
} from "@recall/common"
import {
    HOME_PATH,
    INSTALL_EXTENSION_PATH,
    LOGGING_IN_PATH,
    REDIRECT_PRICING_PATH,
} from "constants/routes"
import { useIsNative } from "hooks/useIsNative"
import { useEffect } from "react"
import { useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router"
import { functions } from "services/firebase/firebaseFunction"
import { RootState } from "storage/redux/rootReducer"
import { isLoggedInSelector } from "storage/redux/user/selector"

export const useRedirectLoggedInUser = () => {
    const isLoggedIn = useSelector(isLoggedInSelector)
    const completedTutorials = useSelector((state: RootState) => state.user.tutorial.completed)
    const location = useLocation()
    const history = useHistory()
    const isNative = useIsNative()
    const { openInNewTab } = useOpenInNewTab()

    const queryParams = new URLSearchParams(location.search)
    const showLoggingInPage = queryParams.has(SHOW_LOGGING_IN_PAGE_QUERY_PARAM)

    const redirectUrl = queryParams.get("redirectUrl")
    const redirect = queryParams.get("redirect")
    const companyID = queryParams.get("companyID")
    const billingPeriod = queryParams.get(CUSTOM_BILLING_PERIOD_PARAM)

    const redirectLoggedInUser = async () => {
        if (billingPeriod) {
            history.push(REDIRECT_PRICING_PATH + location.search)
            return
        }

        if (redirect && companyID) {
            const ssoToken = await functions.generateCannyJwt()
            const url = `https://canny.io/api/redirects/sso?companyID=${companyID}&ssoToken=${ssoToken.data}&redirect=${redirect}`
            if (!isNative) {
                window.location.replace(url)
            } else {
                openInNewTab(url)
            }
            return
        }

        if (redirectUrl) {
            window.location.replace(redirectUrl)
            return
        }

        if (completedTutorials[tutorials.EXTENSION]) {
            history.push(HOME_PATH)
            return
        }

        const { isExtensionInstalled } = await checkExtensionStatus()

        if (!isExtensionInstalled || !completedTutorials.extension) {
            history.push(INSTALL_EXTENSION_PATH)
            return
        }

        history.push(HOME_PATH)
    }

    useEffect(() => {
        if (!isLoggedIn) return
        else if (showLoggingInPage) history.push(LOGGING_IN_PATH)
        else redirectLoggedInUser()
        // eslint-disable-next-line
    }, [isLoggedIn, showLoggingInPage, history])
}
